// src/components/Advantages.jsx
import React from "react";
import {
  Box,
  Container,
  Typography,
  alpha,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { FiSun, FiShield, FiHeadphones, FiTrendingUp } from "react-icons/fi";

const ORANGE = "#FF8A00";
const ORANGE_LIGHT = alpha(ORANGE, 0.12);

const DATA = [
  {
    icon: FiSun,
    title: "Expertos Locales",
    desc: "Soluciones adaptadas al clima y consumo de Hermosillo.",
  },
  {
    icon: FiShield,
    title: "Calidad Garantizada",
    desc: "Componentes Tier-1 con garantías extendidas.",
  },
  {
    icon: FiHeadphones,
    title: "Soporte Post-Venta",
    desc: "Acompañamiento 24/7 después de la instalación.",
  },
  {
    icon: FiTrendingUp,
    title: "Ahorro Comprobado",
    desc: "Clientes con reducciones ≥ 60 % en su recibo de luz.",
  },
];

export default function Advantages() {
  const theme = useTheme();
  const upMd = useMediaQuery(theme.breakpoints.up("md"));

  return (
    <Box
      component="section"
      sx={{
        py: { xs: 8, md: 12 },
        background: "linear-gradient(180deg,#fff 0%,#FFF9F4 100%)",
      }}
    >
      <Container maxWidth="lg">
        <Typography
          variant={upMd ? "h3" : "h4"}
          align="center"
          sx={{
            fontFamily: "Ethos Nova, sans-serif",
            fontWeight: 800,
            mb: { xs: 6, md: 8 },
          }}
        >
          ¿Por Qué&nbsp;
          <Box component="span" sx={{ color: ORANGE }}>
            Elegir KWSOLAR
          </Box>
          ?
        </Typography>

        {/* Grid responsivo, sin overflow */}
        <Box
          sx={{
            display: "grid",
            gap: { xs: 4, md: 6 },
            gridTemplateColumns: {
              xs: "1fr",
              sm: "repeat(2, 1fr)",
              md: "repeat(4, 1fr)",
            },
          }}
        >
          {DATA.map(({ icon: Icon, title, desc }) => (
            <Box
              key={title}
              sx={{
                p: 4,
                borderRadius: 4,
                bgcolor: "#fff",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center",
                boxShadow: `0 6px 20px ${alpha("#000", 0.05)}`,
                borderTop: `4px solid ${ORANGE}`,
                transition: "transform .25s, box-shadow .25s",
                "&:hover": {
                  transform: "translateY(-6px)",
                  boxShadow: `0 12px 30px ${alpha("#000", 0.08)}`,
                },
              }}
            >
              <Box
                sx={{
                  width: 64,
                  height: 64,
                  borderRadius: "50%",
                  display: "grid",
                  placeItems: "center",
                  bgcolor: ORANGE_LIGHT,
                  color: ORANGE,
                  fontSize: 30,
                  mb: 3,
                }}
              >
                <Icon />
              </Box>

              <Typography
                variant="subtitle1"
                sx={{ fontFamily: "Ethos Nova, sans-serif", fontWeight: 700 }}
              >
                {title}
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  mt: 1,
                  fontFamily: "Ethos Nova Italic, serif",
                  lineHeight: 1.6,
                  color: "text.secondary",
                }}
              >
                {desc}
              </Typography>
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
}
